import { IKnmStatus } from 'APIPackage/CatalogsModule/interfaces/IKnmStatus';
import { knmErpMapStatusNameByNewName } from 'KnmErpPackage/MainModule/constants/knmErpMapStatusNameByNewName';

import { IKnmStatusSelectOption } from '../interfaces/IKnmStatusSelectOption';

export const createKnmErpStatusesOption = (status: IKnmStatus, data: IKnmStatus[]): IKnmStatusSelectOption => {
  const filteredData = data.filter(
    item => knmErpMapStatusNameByNewName[item.name] === knmErpMapStatusNameByNewName[status.name],
  );

  return {
    ...status,
    label: knmErpMapStatusNameByNewName[status.name],
    value: status.code,
    generalIds: filteredData.map(item => item.id),
    generalsNames: filteredData.map(item => item.name),
  };
};
